'use client';

import React, { useEffect, useRef, useState } from 'react';
import { usePathname } from 'next/navigation';

interface PageTransitionProps {
  children: React.ReactNode;
}

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  const pathname = usePathname();
  const [displayChildren, setDisplayChildren] = useState(children);
  const [transitionStage, setTransitionStage] = useState<'enter' | 'exit'>('enter');
  const latestChildren = useRef(children);

  useEffect(() => {
    latestChildren.current = children;
  }, [children]);

  useEffect(() => {
    setTransitionStage('exit');
    const timeout = setTimeout(() => {
      setDisplayChildren(latestChildren.current);
      setTransitionStage('enter');
    }, 300);
    return () => clearTimeout(timeout);
  }, [pathname]);

  return (
    <div
      style={{
        animation:
          transitionStage === 'enter' ? 'pageEnter 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards' : 'pageExit 0.3s cubic-bezier(0.4, 0, 1, 1) forwards',
      }}
    >
      {displayChildren}
    </div>
  );
};

export default PageTransition;
